import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import { Box } from '@ovComponents/1-primative/box/box';
import { Typography } from '@ovComponents/1-primative/typography/typography';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

export type DriftQueueEmptyStateProps = {
  /** When true, other breach buckets still have rows — filter-specific copy. */
  filterHasNoMatches?: boolean;
};

export const DriftQueueEmptyState: FC<DriftQueueEmptyStateProps> = ({
  filterHasNoMatches = false,
}) => {
  const { t } = useTranslation(['driftQueue']);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 6,
        gap: 1,
      }}
    >
      {filterHasNoMatches ? (
        <FilterAltOffIcon color='disabled' sx={{ fontSize: 48 }} />
      ) : (
        <CheckCircleOutlineIcon color='success' sx={{ fontSize: 48 }} />
      )}
      <Typography variant='bodyMedium' colorVariant='variant'>
        {filterHasNoMatches
          ? t('driftQueue:empty.filterNoResults')
          : t('driftQueue:empty.title')}
      </Typography>
    </Box>
  );
};
